export default "__VITE_ASSET__CUe3dTnT__"